import React from 'react'

export default function PromotionBuilderProductUpsellPR() {
  return <div>Yolo</div>
}
